import axios from 'axios'

const DISPLAY_SCALE_HEADERS = {
  'X-Display-Weight-Scale': 'display-weight-scale',
  'X-Display-Temperature-Scale': 'display-temperature-scale',
}

export default function() {
  if(document.querySelector('meta[name="csrf-token"]')) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken
    axios.defaults.headers.common['Content-Type'] = 'application/json'

    axios.defaults.params = {}
    axios.defaults.params['format'] = 'json'
  }

  // Report the units this page rendered in, so a form submitted from a tab that
  // was open before the units were switched elsewhere is still read back in the
  // units the user typed into.
  Object.entries(DISPLAY_SCALE_HEADERS).forEach(([header, metaName]) => {
    const scale = document.querySelector(`meta[name="${metaName}"]`)?.getAttribute('content')
    if(scale) axios.defaults.headers.common[header] = scale
  })
}
